export default {
  clientCase: {
    NETWORK: {
      title: '手机QQ',
      imgUrl: require('../img/case/logos_360px_qq.png'),
      content: '手机QQ是移动互联网领航级手机应用，服务超过5.7亿的月活跃用户。手Q中的名片识别功能由优图团队和手Q团队联合打造。在日常社交中，扫描下名片即可方便的保存好友姓名，电话，QQ号等信息。'
    },
    FINANCE: {
      title: '微众银行',
      imgUrl: require('../img/case/logos_360px_webank.png'),
      content: '微众银行是国内首家互联网银行，微众的远程核身流程应用了优图的人脸检测和人脸核身技术。李克强总理2015年1月4日亲自视察WeBank银行，当场见证了微众银行人脸核身演示。凭借世界顶尖的人脸验证、声纹验证、语音识别等技术，在智能手机上安全、有效的解决实名制远程用户核身验证的难题，属国内首创。'
    },
    OTHER: {
      title: '微影时代',
      imgUrl: require('../img/case/logos_360px_wysd.png'),
      content: '腾讯优图助力微影时代建设人脸识别智能闸机，主要用于工作人员人脸验证入场和观众人脸识别入场两种业务场景。其中工作人员人脸验证入场使用1:1人脸对比技术能迅速判断出是否为同一人，观众识别入场使用1:N人脸检索技术迅速判断出该观众是否是购票用户。它能够有效记录用户入场行为，保证演出现场安全，并能防止黄牛囤票、出售假票的情况，在提升验票效率的同时，将验票体验也一同升级。'
    }
  },
  moreCase: {
    NETWORK: [
      require('../img/network/logos_220px_qzone.png'),
      require('../img/network/logos_220px_qqmusic.png'),
      require('../img/network/logos_220px_wesing.png'),
      require('../img/network/logos_220px_didi.png'),
      require('../img/network/logos_220px_webank.png'),

      require('../img/network/logos_220px_pitu.png'),
      require('../img/network/logos_220px_weiyun.png'),
      require('../img/network/logos_220px_qqmanager.png'),
      require('../img/network/logos_220px_penguinfm.png'),
      require('../img/network/logos_220px_zzb.png'),

      require('../img/network/logos_220px_kb.png'),
      require('../img/network/logos_220px_tsa.png'),
      require('../img/network/logos_220px_myapp.png'),
      require('../img/network/logos_220px_enterprise.png'),
      require('../img/network/logos_220px_egame.png'),

      require('../img/network/logos_220px_wzq.png'),
      require('../img/network/logos_220px_tenpay.png'),
      require('../img/network/logos_220px_lct.png'),
      require('../img/network/logos_220px_wetest.png'),
      require('../img/network/logos_220px_qidian.png'),

      require('../img/network/logos_220px_douyu.png'),
      require('../img/network/logos_220px_workwx.png'),
      require('../img/network/logos_220px_dzh.png'),
      require('../img/network/logos_220px_longzhu.png'),
      require('../img/network/logos_220px_milive.png'),

      require('../img/network/logos_220px_qmtv.png'),
      require('../img/network/logos_220px_zqzb.png'),
      require('../img/network/logos_220px_bilibili.png'),
      require('../img/network/logos_220px_qezb.png'),
      require('../img/network/logos_220px_kd100.png'),

      require('../img/network/logos_220px_6cn.png'),
      require('../img/network/logos_220px_58tc.png'),
      require('../img/network/logos_220px_baomihua.png'),
      require('../img/network/logos_220px_hivebox.png'),
      require('../img/network/logos_220px_huyatv.png'),

      require('../img/network/logos_220px_kuaikan.png'),
      require('../img/network/logos_220px_kuaishou.png'),
      require('../img/network/logos_220px_mobike.png'),
      require('../img/network/logos_220px_pandatv.png'),
      require('../img/network/logos_220px_udcredit.png'),

      require('../img/network/logos_220px_voovtv.png'),
      require('../img/network/logos_220px_wechatpay.png'),
      require('../img/network/logos_220px_yktv.png'),
      require('../img/network/logos_220px_yytv.png')
    ],
    FINANCE: [
      require('../img/finance/logos_220px_wzq.png'),
      require('../img/finance/logos_220px_tenpay.png'),
      require('../img/finance/logos_220px_lct.png'),
      require('../img/finance/logos_220px_tlsw.png'),
      require('../img/finance/logos_220px_citicbank.png'),

      require('../img/finance/logos_220px_lyr.png'),
      require('../img/finance/logos_220px_qnn.png'),
      require('../img/finance/logos_220px_nxfq.png'),
      require('../img/finance/logos_220px_mxd.png'),
      require('../img/finance/logos_220px_jlc.png'),

      require('../img/finance/logos_220px_hfepay.png'),
      require('../img/finance/logos_220px_yxcd.png'),
      require('../img/finance/logos_220px_aixinlife.png'),
      require('../img/finance/logos_220px_bocomlife.png'),
      require('../img/finance/logos_220px_cupdata.png'),

      require('../img/finance/logos_220px_eastmoney.png'),
      require('../img/finance/logos_220px_msxf.png'),
      require('../img/finance/logos_220px_xiaowo.png'),
      require('../img/finance/logos_220px_yingkou.png'),
      require('../img/finance/logos_220px_zhongzilian.png')
    ],
    PEOPLE_LIFE: [
      require('../img/peoplelife/logos_220px_nn_gongan.png'),
      require('../img/peoplelife/logos_220px_szhou_gongan.png'),
      require('../img/peoplelife/logos_220px_chinaunicom.png'),
      require('../img/peoplelife/logos_220px_tenglv.png'),
      require('../img/peoplelife/logos_220px_ems.png'),

      require('../img/peoplelife/logos_220px_cd_shuiwu.png'),
      require('../img/peoplelife/logos_220px_fj_gongan.png'),
      require('../img/peoplelife/logos_220px_nx_jinrong.png'),
      require('../img/peoplelife/logos_220px_fj_renshe.png'),
      require('../img/peoplelife/logos_220px_sz_gongan.png'),

      require('../img/peoplelife/logos_220px_sz_renshe.png'),
      require('../img/peoplelife/logos_220px_gs_ggs.png'),
      require('../img/peoplelife/logos_220px_chinatele.png'),
      require('../img/peoplelife/logos_220px_sinotrans.png'),
      require('../img/peoplelife/logos_220px_tj_gongan.png'),

      require('../img/peoplelife/logos_220px_xm_jx.png')
    ],
    SAFETY: [
      require('../img/safety/logos_220px_hlmj.png'),
      require('../img/safety/logos_220px_tjbhairport.png')
    ],
    OTHER: [
      require('../img/other/logos_220px_effmaster.png')
    ]
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/cooperation/js/Cooperation.js